import { CFormSelect } from "@coreui/react";
import { requester } from "App";
import { textFormat } from "InitialData/regExp";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import CheckCircle from "components/inputs/checkBox/CheckCircle";
import InputImage from "components/inputs/image/InputImage";
import QuillEditor from "components/inputs/richEditor/QuillEditor";
import InputHashTag from "components/inputs/signUp/InputHashTag";
import InputNumber from "components/inputs/signUp/InputNumber";
import InputText from "components/inputs/signUp/InputText";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { validateInputs } from "shared/utils/Utils";

function AdminProductRegister(props) {
    const inputs = useRef([]);
    const location = useLocation();
    const [product, setProduct] = useState();
    const [categories, setCategories] = useState();
    const [selectedCategory, setSelectedCategory] = useState();
    const [detailOption, setDetailOption] = useState(false);

    useEffect(() => {
        let data = { storeId: "root" }
        requester.findAllCategories(data, (result) => {
            const filteredCategories = result.data.filter(category => category.parentCategoryId != null);
            
            setCategories(filteredCategories);
            
        })
    }, [])

    useEffect(() => {
        if (location) {
            
            setProduct(location.state.data);
            setSelectedCategory(location.state.data.categoryId || "");
            inputs.current[10].setValue(location.state.data.hashTag || "");
        }
    }, [location])




    const onClick = () => {
        let data = {
            storeId: "root",
            productName: "",
            price: "",
            productImg: "",
            radarImg: "",
            bannerTextImg: "",
            liquidImg: "",
            productDetailImg: "",
            supplyPrice: "",
            productBgImg: "",
            categoryId: selectedCategory === "" ? null : selectedCategory,
            sweetPoint: detailOption ? inputs.current[13].getValue() : 0,
            throatHitPoint: detailOption ? inputs.current[14].getValue() : 0,
            hittingPoint: detailOption ? inputs.current[15].getValue() : 0,
            freshingPoint: detailOption ? inputs.current[16].getValue() : 0,
            bodyPoint: detailOption ? inputs.current[17].getValue() : 0

        }
        
        validateInputs(inputs.current).then((result) => {

            if (result.isValid) {
                data.productName = inputs.current[0].getValue();
                data.price = inputs.current[1].getValue();
                data.productImg = inputs.current[2].getValue();
                data.radarImg = inputs.current[3].getValue();
                data.liquidImg = inputs.current[4].getValue();
                data.bannerTextImg = inputs.current[5].getValue();
                data.productDetailImg = inputs.current[6].getValue();
                data.quantity = inputs.current[7].getValue();
                data.supplyPrice = inputs.current[8].getValue();
                data.productBgImg = inputs.current[9].getValue();
                data.hashTag = inputs.current[10].getValue();
                data.oneLineReview = inputs.current[11].getValue();
                
                
                requester.updateProduct(data, (result) => {
                    
                    if (result.code === 0) {

                        // setProduct(result.data);
                        // toast.error(`상품등록이 완료되었습니다`, {
                        //     autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                        // });
                    }
                });

            } else {
                toast.error(`${inputs.current[result.index].getName()} 항목을 확인해주세요`, {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
            }


        });

    }
    const handleSelectChange = (event) => {
        // 여기에서 선택된 카테고리의 ID를 사용할 수 있습니다.
        
        setSelectedCategory(event.target.value);
    };

    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none"
    }
    const detailOptionClick = (index, checked) => {
        setDetailOption(checked);
    }
    
    return (
        <Container>
            <Container maxWidth={1200}>
                <Center width={"100%"} textAlign={"left"}>
                    <P size={40} font={"gmarketSansBold"}>상품등록</P>
                </Center>
                <VerticalFlex flexStart padding={"30px"} gap={20}>

                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>상품명 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputText ref={el => (inputs.current[0] = el)} placeHolder={"상품명"} regExp={[textFormat]} value={product && product.productName}  />
                            </FlexChild>
                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>상품가격 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputText ref={el => (inputs.current[1] = el)} placeHolder={"상품가격"} regExp={[textFormat]} value={product && product.price} />
                            </FlexChild>

                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>상품공급가격 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputText ref={el => (inputs.current[8] = el)} placeHolder={"상품공급가격"} regExp={[textFormat]} value={product && product.supplyPrice} />
                            </FlexChild>

                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>상품 이미지 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputImage ref={el => (inputs.current[2] = el)} name={"상품 라벨"} path={"product/"} labelWidth={0} cropWidth={200} cropHeight={200} value={product && product.productImg} maxSizeMb={1} />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>상품스펙 이미지 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputImage ref={el => (inputs.current[3] = el)} name={"상품 라벨"} path={"product/"} labelWidth={0} cropWidth={200} cropHeight={200} value={product && product.radarImg} maxSizeMb={1} />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>액상 이미지 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputImage ref={el => (inputs.current[4] = el)} name={"상품 라벨"} path={"product/"} labelWidth={0} cropWidth={200} cropHeight={200} value={product && product.liquidImg} maxSizeMb={1} />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>배너글씨 이미지 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputImage ref={el => (inputs.current[5] = el)} name={"상품 라벨"} path={"product/"} labelWidth={0} cropWidth={200} cropHeight={50} value={product && product.bannerTextImg} maxSizeMb={1} />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>액상배경 이미지 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputImage ref={el => (inputs.current[9] = el)} name={"액상 배경"} path={"product/"} labelWidth={0} cropWidth={350} cropHeight={350} value={product && product.productBgImg} maxSizeMb={1} />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>상품상세 이미지 : </P>
                            </FlexChild>
                            <FlexChild height={"100%"}>
                                <div style={{ maxWidth: "1200px" }}>
                                    <QuillEditor ref={el => (inputs.current[6] = el)} name={"상세"} value={product && product.productDetailImg} path={"product/" + "product.id"} preview={true} />
                                </div>
                            </FlexChild>
                            {/* <FlexChild>
                        <InputImage ref={el => (inputs.current[6] = el)} name={"상품 라벨"} path={"product/"} labelWidth={0} value={product && product.image ? product.image : ""} maxSizeMb={1} cropWidth={800} cropHeight={800} />
                    </FlexChild> */}
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>상품수량 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputText ref={el => (inputs.current[7] = el)} placeHolder={"상품수량"} regExp={[textFormat]} value={product && product.quantity} />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>카테고리 : </P>
                            </FlexChild>
                            <FlexChild>
                                <CFormSelect value={selectedCategory} onChange={handleSelectChange}>
                                    <option value={""}>선택하세요</option>
                                    {categories && categories.map((category) => (
                                        <option key={category.id} value={product ? product.categoryId : category.id}>
                                            {category.categoryName}
                                        </option>
                                    ))}
                                </CFormSelect>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>

                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>해시태그 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputHashTag value={product && product.hashTag} ref={el => (inputs.current[10] = el)} placeHolder={"해시태그"} />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>한줄평 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputHashTag value={product && product.oneLineReview} oneLineReview ref={el => (inputs.current[11] = el)} placeHolder={"한줄평"} />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>


                        <HorizontalFlex gap={30} justifyContent={"flex-start"}>
                            <FlexChild width={"20%"} >
                                <P>상품 상세 : </P>
                            </FlexChild>
                            <FlexChild justifyContent={"flex-start"} width={"30%"}>
                                <CheckCircle callback={detailOptionClick} ref={el => (inputs.current[12] = el)} />
                            </FlexChild>
                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>


                        <HorizontalFlex gap={30} justifyContent={"flex-start"}>
                            <FlexChild width={"20%"} >
                                <P>단맛 : </P>
                            </FlexChild>
                            <FlexChild justifyContent={"flex-start"} width={"30%"}>
                                <InputNumber min={0} max={5} disabled={!detailOption} ref={el => (inputs.current[13] = el)} />
                            </FlexChild>
                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>


                        <HorizontalFlex gap={30} justifyContent={"flex-start"}>
                            <FlexChild width={"20%"} >
                                <P>멘솔 : </P>
                            </FlexChild>
                            <FlexChild justifyContent={"flex-start"} width={"30%"}>
                                <InputNumber min={0} max={5} disabled={!detailOption} ref={el => (inputs.current[14] = el)} />
                            </FlexChild>
                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>


                        <HorizontalFlex gap={30} justifyContent={"flex-start"}>
                            <FlexChild width={"20%"} >
                                <P>타격감 : </P>
                            </FlexChild>
                            <FlexChild justifyContent={"flex-start"} width={"30%"}>
                                <InputNumber min={0} max={5} disabled={!detailOption} ref={el => (inputs.current[15] = el)} />
                            </FlexChild>
                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>


                        <HorizontalFlex gap={30} justifyContent={"flex-start"}>
                            <FlexChild width={"20%"} >
                                <P>상큼함 : </P>
                            </FlexChild>
                            <FlexChild justifyContent={"flex-start"} width={"30%"}>
                                <InputNumber min={0} max={5} disabled={!detailOption} ref={el => (inputs.current[16] = el)} />
                            </FlexChild>
                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>


                        <HorizontalFlex gap={30} justifyContent={"flex-start"}>
                            <FlexChild width={"20%"} >
                                <P>바디감 : </P>
                            </FlexChild>
                            <FlexChild justifyContent={"flex-start"} width={"30%"}>
                                <InputNumber min={0} max={5} disabled={!detailOption} ref={el => (inputs.current[17] = el)} />
                            </FlexChild>
                        </HorizontalFlex>

                    </FlexChild>

                    <FlexChild>
                        <CustomButton style={btnStyle} text={"상품 등록"} onClick={onClick} />
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </Container >
    );
}

export default AdminProductRegister;